export const getRelativeTime = (dateString) => {
    const now = new Date()
    const created = new Date(dateString)
    const diffMs = now.getTime() - created.getTime()
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
    const diffMinutes = Math.floor(diffMs / (1000 * 60))

    if (diffMinutes < 60) {
        return diffMinutes <= 1 ? 'Posted just now' : `Posted ${diffMinutes}m ago`
    } else if (diffHours < 24) {
        return `Posted ${diffHours}h ago`
    } else if (diffDays < 7) {
        return `Posted ${diffDays}d ago`
    } else if (diffDays < 30) {
        const weeks = Math.floor(diffDays / 7)
        return `Posted ${weeks}w ago`
    } else {
        const options = created.getFullYear() !== now.getFullYear()
            ? { month: 'short', day: 'numeric', year: 'numeric' }
            : { month: 'short', day: 'numeric' }
        return created.toLocaleDateString('en-US', options)
    }
}
